import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';

export default function Services() {
  const [ref, isInView] = useInView({ threshold: 0.1 });

  const services = [
    {
      icon: 'ri-calendar-event-line',
      title: 'Organizzazione Eventi',
      description: 'Pianificazione e gestione di eventi aziendali, conferenze, lancio prodotti e team building, garantendo un\'esperienza personalizzata e di alta qualità.',
    },
    {
      icon: 'ri-megaphone-line',
      title: 'Campagne di Marketing',
      description: 'Creiamo campagne di marketing innovative e su misura per supportare la crescita del tuo brand, dalla strategia alla realizzazione, per un impatto duraturo.',
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Ricerche di Mercato',
      description: 'Offriamo analisi di mercato accurate e approfondite per guidare le tue decisioni aziendali con dati concreti e analitici.',
    },
    {
      icon: 'ri-store-3-line',
      title: 'Eventi Fieristici',
      description: 'Organizzazione di eventi fieristici di grande prestigio, con soluzioni di catering esclusive per ogni tipo di occasione.',
    },
    {
      icon: 'ri-steering-2-line',
      title: 'Motorsport Events',
      description: 'Organizzazione di eventi di motorsport di livello mondiale, con particolare attenzione ai dettagli e alla qualità dell\'esperienza.',
    },
    {
      icon: 'ri-advertisement-line',
      title: 'Campagne Pubblicitarie',
      description: 'Gestiamo campagne pubblicitarie online e offline per massimizzare la visibilità del tuo brand e aumentarne la notorietà in modo efficace.',
    },
  ];

  return (
    <section id="servizi" ref={ref} className="py-24 md:py-32 bg-gradient-to-b from-gray-light to-white px-4">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-20"
        >
          <div className="inline-block bg-primary/10 text-primary px-4 py-2 rounded-full text-xs font-bold uppercase mb-6 whitespace-nowrap">
            I Nostri Servizi
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-dark max-w-3xl mx-auto leading-tight">
            Soluzioni Complete per il Tuo Successo
          </h2>
        </motion.div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white rounded-3xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group cursor-pointer"
            >
              {/* Icon */}
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-primary to-primary/70 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${service.icon} text-white text-2xl`}></i>
              </div>

              {/* Content */}
              <h3 className="text-xl font-bold text-dark mb-4">
                {service.title}
              </h3>
              <p className="text-gray-medium leading-relaxed mb-6">
                {service.description}
              </p>

              {/* Link */}
              <a
                href="#contatti"
                className="inline-flex items-center gap-2 text-primary font-semibold text-sm hover:gap-3 transition-all whitespace-nowrap"
              >
                Scopri di più
                <i className="ri-arrow-right-line"></i>
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}